import React from "react";
import ScorecardSummaryRowPlayerNameCell from "./ScorecardSummaryRowPlayerNameCell";
import "./ScorecardSummaryTableSticky.css"; // Import the CSS file
import ScorecardSummaryRowHoleScoreCell from "./ScorecardSummaryRowHoleScoreCell";
import ScorecardSummaryRowTotalScoreCell from "./ScorecardSummaryRowTotalScoreCell";

function ScorecardSummaryTableStickyRow({
  player,
  throwScoringModeId,
  small,
  managePage,
}) {
  const holes = player.event_entries.hole_scores;

  // if small is not passed in, set to false
  if (small === undefined) {
    small = false;
  }

  // sort holes by hole_order
  holes.sort((a, b) =>
    a.layout_holes.hole_order > b.layout_holes.hole_order
      ? 1
      : b.layout_holes.hole_order > a.layout_holes.hole_order
      ? -1
      : 0
  );

  //calculate this players total score
  let total = 0;
  let isEmptyHole = "false";
  player.event_entries.hole_scores.forEach((score, index) => {
    total += score.score;
    if (score.score === null) {
      isEmptyHole = "true";
    }
  });

  //calculate this players total+ score
  let totalPlus = 0;
  player.event_entries.hole_scores.forEach((score, index) => {
    totalPlus += score.hole_score_adv;
  });

  return (
    <tr>
      <ScorecardSummaryRowPlayerNameCell
        player={player.event_entries.users_public.name}
      />
      {holes.map((score, index) => (
        <React.Fragment key={index}>
          <ScorecardSummaryRowHoleScoreCell
            score={score}
            index={index}
            throwScoringModeId={throwScoringModeId}
            small={small}
          />
        </React.Fragment>
      ))}

      <ScorecardSummaryRowTotalScoreCell
        total={total}
        isDnf={player.event_entries.is_dnf}
        isEmptyHole={isEmptyHole}
        needsLeftBorder={true}
      />

      {managePage && (
        <ScorecardSummaryRowTotalScoreCell
          total={player.event_entries.score_adv}
          isDnf={player.event_entries.is_dnf}
          isEmptyHole={isEmptyHole}
          needsLeftBorder={true}
        />
      )}

      {throwScoringModeId > 1 && (
        <ScorecardSummaryRowTotalScoreCell
          total={totalPlus}
          isDnf={player.event_entries.is_dnf}
          isEmptyHole={isEmptyHole}
          needsLeftBorder={false}
        />
      )}
    </tr>
  );
}

export default ScorecardSummaryTableStickyRow;
